import { Button } from "@/shared/components";
import { cn } from "@/shared/utils";
import React from "react";
import { Toaster as Sonner, ToasterProps } from "sonner";

/**
 * Base component for showing toasts using Sonner.
 */
export function Toaster({ ...props }: Readonly<ToasterProps>) {
    return (
        <Sonner
            className="toaster group pointer-events-auto flex items-center justify-center"
            style={
                {
                    "--normal-bg": "var(--popover)",
                    "--normal-text": "var(--popover-foreground)",
                    "--normal-border": "var(--border)",
                } as React.CSSProperties
            }
            position="bottom-right"
            {...props}
        />
    );
}

interface ToastProps {
    title: string;
    className?: string;
    description?: string;
    action?: () => void;
}

export function Toast({ title, description, action, className }: Readonly<ToastProps>) {
    return (
        <div data-testid="toast" className={cn(className, "bg-brand-secondary shadow-elevated-1 flex w-full items-center rounded-lg p-4")}>
            <div className="flex flex-1 justify-between">
                <div className="flex">
                    <p className="text-s text-content-default-inverse mt-1">{description ?? title}</p>
                </div>
                {action && (
                    <Button variant="tertiary" inverse onClick={action} size="s" className="flex">
                        Ongedaan maken
                    </Button>
                )}
            </div>
        </div>
    );
}

type ImportantToastProps = {
    title: string;
    description: string;
    actionLabel: string;
    action: () => void;
};

export function ImportantToast({ title, description, actionLabel, action }: ImportantToastProps) {
    return (
        <div className="bg-brand-secondary shadow-elevated-1 flex w-full min-w-[600px] items-center rounded-lg p-4">
            <div className="flex w-full flex-row items-center justify-between gap-4">
                <div className="flex flex-col">
                    <p className="text-m text-content-default-inverse mt-1">{title}</p>
                    <p className="text-s text-content-default-inverse mt-1">{description}</p>
                </div>
                <Button variant="tertiary" inverse onClick={action} className="flex">
                    {actionLabel}
                </Button>
            </div>
        </div>
    );
}
